import "./resto-detail.scss";

const RestoDetail = ({name, address, locality, city, avgPrice, type, expBtn, onExploreClick}) => {
  return (
    <div className="resto-details-card">
        <span className="resto-name">{name}</span>
        {address && 
            <span className="resto-address">{address}</span>
        }
        <span className="resto-info">{locality}, {city}</span>
        {!expBtn && 
          <span className="resto-other-info">{avgPrice}. {type}</span>
        }
        {expBtn && 
         <div className="exploreButton" onClick={onExploreClick}>
            Explore
         </div>
        }
    </div>
  )
}

export default RestoDetail